import { createContext } from 'react';

import * as Types from './types';

export const ComponentPropsContext = createContext<any>({});
export const ComponentConfigContext = createContext<any>({});
export const ComponentMethodsContext = createContext({} as Types.IComponentMethodsContext);
